import React, { createContext } from "react";

export interface IAdminContextProps {
    emailSettings: any;
    generalSettings: any;
    licenseSettings: any;
    tableSettings: any;
    logSettings: any
    setEmailSettings: Function;
    setGeneralSettings: Function;
    setLicenseSettings: Function;
    setTableSettings: Function;
    setLogSettings: Function;
}

export const AdminContext = createContext<IAdminContextProps>({} as IAdminContextProps);
